import { AbstractPmsApiService } from "./abstract.service";
import { CashDrawer } from "../models";

/**
 * @class CashDrawerPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<CashDrawer>}
 */
export class CashDrawerPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/cash-drawer(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {CashDrawer}
     * @protected
     */
    newModel(attributes, ...params) {

        return new CashDrawer(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<CashDrawer>>}
     */
    get (params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {CashDrawer} cashDrawer
     * @param {Property} property
     * @returns {Promise.<CashDrawer>}
     */
    create(cashDrawer, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, cashDrawer.toObjectExcept('property', 'user', 'user_name'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {CashDrawer} cashDrawer
     * @param {Property} property
     * @returns {Promise.<CashDrawer>}
     */
    show(cashDrawer, property) {

        const url = this.url({
            propertyId: property.id,
            id: cashDrawer.id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {CashDrawer} cashDrawer
     * @returns {Promise.<CashDrawer>}
     */
    update(cashDrawer) {

        const url = this.url({
            propertyId: cashDrawer.property.id,
            id:         cashDrawer.id
        });

        return this.http
            .put(url, cashDrawer.toObjectExcept('property', 'user', 'user_name'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {CashDrawer} cashDrawer
     * @returns {Promise.<boolean>}
     */
    delete(cashDrawer) {

        const url = this.url({
            propertyId: cashDrawer.property.id,
            id:         cashDrawer.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    cashDrawersByUser() {

        return this.http
            .get(this.endpoint + '/cash-drawers-by-user', {
                headers: this.authHeaders,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    open(model) {

        const url = this.url({
            propertyId: model.drawer.property.id,
            id:         model.drawer.id
        });

        return this.http
            .put(url + '/open', model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    close(model) {

        const url = this.url({
            propertyId: model.drawer.property.id,
            id:         model.drawer.id
        });

        return this.http
            .put(url + '/close', model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    cashDrawersWithClosedShifts(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url + 's-with-closed-shifts', {
                headers: this.authHeaders,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/cash-drawer.service.js